import { Component, Input } from "@angular/core"
import { LocalizationModalComponent } from "../../shared-components/modals/localization-modal/localization-modal.component"
import { ModalService } from "../../shared-components/modal/modal.service"
import { Observable } from "rxjs"

@Component({
    selector: "app-user-localization",
    templateUrl: "./user-localization.component.html",
    styleUrls: ["./user-localization.component.scss"],
})
export class UserLocalizationComponent {
    @Input()
    localizeData$: Observable<any>

    @Input()
    showStateStandards: boolean

    constructor(private modalService: ModalService) {}

    openLocalizationChangeModal(): void {
        this.modalService.open(LocalizationModalComponent, {
            size: "lg",
            windowClass: "change-station-modal",
        })
    }
}
